var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.95,21.36V3.05c0-1.73,1.32-3.05,3.05-3.05s3.05,1.32,3.05,3.05V21.36c0,1.63-1.32,3.05-3.05,3.05s-3.05-1.32-3.05-3.05Zm18.51-12.76c-1.22-1.12-3.15-.92-4.27,.31-1.12,1.22-1.02,3.15,.31,4.27,.61,.51,1.22,1.12,1.73,1.73,6.41,7.32,5.59,18.31-1.73,24.72-7.32,6.41-18.41,5.59-24.72-1.73-6.41-7.32-5.59-18.41,1.73-24.72,1.32-1.12,1.42-2.95,.31-4.27-1.12-1.32-2.95-1.42-4.27-.31C4.35,13.07,1.4,19.58,1.4,26.4c0,13.02,10.58,23.6,23.6,23.6,6.82,0,13.33-2.95,17.8-8.14h0c8.54-9.77,7.53-24.72-2.34-33.26Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.6c94e17ee77f71355eabfb8d67190974.svg";
export { ForwardRef as ReactComponent };